import React from "react";
import { Link } from "react-router-dom";

function Promos() {
  return (
    <div className="bg-gray-900 text-white rounded-xl pt-20 lg:py-2 grid lg:grid-cols-2 gap-6">
      <div className="flex lg:text-start text-center flex-col items-center lg:px-0 px-4 sm:px-12 lg:items-start gap-4 lg:pl-24 lg:py-20">
        <h1 className="text-2xl font-medium">
          Still looking for the best{" "}
          <span className="text-yellowlight font-semibold">
            Nails & Beauty Salon?
          </span>
        </h1>
        <p className="text-lg text-gray-300 leading-7">
          <span className="text-yellowlight ">Diamond Nail Blenheim</span> is
          your go-to destination for beauty and self-care. From expert nail
          services to indulgent beauty treatments, we offer everything you need
          to feel confident, pampered, and refreshed. Enjoy top-tier service at
          prices you'll love.{" "}
          <span className="text-yellowlight font-medium">
            What are you waiting for?
          </span>{" "}
          Book your appointment today!
        </p>
        <p className="text-yellowlight text-xl font-bold flex flex-wrap gap-4 items-center">
          <span>🌸 Playful</span>
          <span>💎 Luxurious</span>
          <span>🧑 Professional</span>
        </p>
        <Link
          target="_blank"
          to="/"
          className="bg-yellow-500 flex-colo hover:scale-105 transitions hover:bg-yellow-700 lg:py-3 py-4 font-semibold w-44 rounded-md text-xs lg:text-sm text-white"
        >
          GET STARTED
        </Link>
      </div>
      <div className="flex-colo">
        <img
          src="/images/nail_hero.jpg"
          alt="promo"
          className="w-full sm:h-72 object-cover rounded"
        />
      </div>
    </div>
  );
}

export default Promos;
